/**
 * NEX-1666 F2: the questions panel of a synthetic request, loaded on demand. It renders inside the
 * legacy request detail (`src/pages/ShipmentDetails.tsx`), which may not import a feature, so
 * `src/app/router.tsx` passes it in. Its own file because `routes.tsx` exports a route table, and
 * fast refresh wants a file of components only.
 */
import { lazy } from 'react';

export const LazySyntheticQuestionsPanel = lazy(() =>
    import('./components/SyntheticQuestionsPanel').then((module) => ({ default: module.SyntheticQuestionsPanel })),
);
